import request from '@/utils/request'

const baseUrl = process.env.VUE_APP_BIDDOG_API

// ------------------------------ 采购单位画像 --------------------------------

// 采购单位画像列表
export function getRiskPortraitPurchaserListApi(params) {
  return request({
    url: baseUrl + '/data/risk/purchaser/portrait/list',
    method: 'get',
    params
  })
}

// ------------------------------ 投标单位画像 --------------------------------

// 采购单位画像列表
export function getRiskPortraitSupplierListApi(params) {
  return request({
    url: baseUrl + '/data/risk/supplier/portrait/list',
    method: 'get',
    params
  })
}

// 获取当前登录的员工的监管范围内项目的所有投标单位
export function getRiskPortraitTradeListApi(params) {
  return request({
    url: baseUrl + '/data/risk/supplier/portrait/trade/list',
    method: 'get',
    params
  })
}

// 云采购的公司信息表
export function getRiskCompanyInfoApi(params) {
  return request({
    url: baseUrl + '/data/company/dim/info',
    method: 'get',
    params
  })
}

// 通过公司统一社会信用代码查询公司的注册相关信息
export function getRiskCompanyOpenInfoApi(params) {
  return request({
    url: baseUrl + '/data/company/open/info',
    method: 'get',
    params
  })
}

// 通过企查查的公司id，获取公司的信息变更记录
export function getRiskCompanyChangeRecordApi(params) {
  return request({
    url: baseUrl + '/data/company/change/record',
    method: 'get',
    params
  })
}

// 风险分析
export function getRiskPortraitSupplierStatisticsApi(params) {
  return request({
    url: baseUrl + `/data/risk/supplier/portrait/risk/total`,
    method: 'get',
    params
  })
}

// 项目风险趋势
export function getRiskPortraitSupplierTrendApi(params) {
  return request({
    url: baseUrl + `/data/risk/supplier/portrait/risk/trend/month`,
    method: 'get',
    params
  })
}

// 风险等级分布
export function getRiskPortraitSupplierLevelApi(params) {
  return request({
    url: baseUrl + `/data/risk/supplier/portrait/risk/level`,
    method: 'get',
    params
  })
}

// 通过投标单位查竞争对手
export function getRiskSupplierCompetitorOrderApi(params) {
  return request({
    url: baseUrl + `/data/risk/supplier/competitor/order`,
    method: 'get',
    params
  })
}

// 通过投标单位查重复Mac地址的投标单位
export function getRiskSupplierCompetitorMacidApi(params) {
  return request({
    url: baseUrl + `/data/risk/supplier/competitor/macid`,
    method: 'get',
    params
  })
}

// 通过投标单位查重复ip的投标单位
export function getRiskSupplierCompetitorIpApi(params) {
  return request({
    url: baseUrl + `/data/risk/supplier/competitor/ip`,
    method: 'get',
    params
  })
}
